<template>
  <ForumDialog class="forum-next-image-viewer" :label="title" :request-close="close">
    <header class="forum-next-image-viewer__header">
      <h2>{{ title }}</h2>
      <button type="button" class="forum-next-button" aria-label="Cerrar imagen" @click="close"><i class="pi pi-times" aria-hidden="true"></i></button>
    </header>
    <div ref="stage" class="forum-next-image-viewer__stage" :class="{ 'is-original': original }" :aria-busy="status === 'loading' ? 'true' : 'false'" role="region" tabindex="0" aria-label="Imagen ampliada">
      <p v-if="status === 'loading'" role="status">Cargando imagen…</p>
      <div v-if="status === 'error'" role="alert"><p>No se pudo cargar la imagen.</p><button type="button" class="forum-next-button" @click="retry">Reintentar</button></div>
      <img v-else :key="attempt" v-show="status === 'ready'" :src="image.src" :alt="image.alt" @load="loaded" @error="status = 'error'">
    </div>
    <footer class="forum-next-image-viewer__footer">
      <p v-if="image.alt">{{ image.alt }}</p>
      <button type="button" class="forum-next-button" :disabled="status !== 'ready'" :aria-pressed="original ? 'true' : 'false'" @click="toggleSize">{{ original ? 'Ajustar a pantalla' : 'Tamaño original' }}</button>
    </footer>
  </ForumDialog>
</template>
<script>
import ForumDialog from './ForumDialog.vue';
export default {
  name: 'ForumImageViewer', components: { ForumDialog },
  props: { image: { type: Object, required: true }, postNumber: { type: Number, required: true } },
  data: () => ({ status: 'loading', original: false, attempt: 0 }),
  computed: { title() { return 'Imagen del mensaje #' + this.postNumber; } },
  watch: { image() { this.retry(); } },
  methods: {
    close() { this.$emit('close'); },
    loaded(event) { this.status = event.target.naturalWidth > 0 ? 'ready' : 'error'; },
    retry() { this.status = 'loading'; this.original = false; this.attempt++; this.$nextTick(() => { if (this.$refs.stage) this.$refs.stage.focus({ preventScroll: true }); }); },
    toggleSize() { this.original = !this.original; this.$nextTick(() => { this.$refs.stage.scrollTop = 0; this.$refs.stage.scrollLeft = 0; }); }
  }
};
</script>
<style lang="scss">
.forum-next-image-viewer .forum-next-dialog__surface { display: flex; flex-direction: column; gap: 12px; overflow: hidden; height: 100%; max-width: 1280px; }
.forum-next-image-viewer__header { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-shrink: 0; }
.forum-next-image-viewer__header h2 { margin: 0; font-size: 16px; line-height: 1.4; }
.forum-next-image-viewer__header button { flex-shrink: 0; min-width: 44px; }
.forum-next-image-viewer__stage { flex: 1; min-height: 0; min-width: 0; overflow: auto; display: flex; align-items: center; justify-content: center; background: var(--modern-bg); border-radius: 8px; padding: 8px; }
.forum-next-image-viewer__stage img { display: block; max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; }
.forum-next-image-viewer__stage.is-original { display: block; }
.forum-next-image-viewer__stage.is-original img { max-width: none; max-height: none; margin: auto; }
.forum-next-image-viewer__footer { flex-shrink: 0; display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-end; gap: 8px 16px; }
.forum-next-image-viewer__footer p { flex: 1 1 200px; min-width: 0; overflow-wrap: anywhere; margin: 0; max-height: 5em; overflow: auto; font-size: 14px; color: var(--modern-muted); }
</style>
